<script>
import Vue from 'vue';

export default {
    name: 'list-group-item',

    props: {
        isActive: {
            type: Boolean,
            default: false
        },

        isDisabled: {
            type: Boolean,
            default: false
        },

        variant: {
            type: String,
            default: null
        },

        link: {
            type: String,
            default: 'javascript:;'
        },

        badgeContent: {
            type: [String, Number],
            default: undefined
        }
    },

    computed: {
        classObject() {
            return [
                'list-group-item',
                this.isActive ? 'active' : null,
                this.isDisabled ? 'disabled' : null,
                this.class
            ];
        },

        hasBadgeContent() {
            return typeof this.badgeContent !== 'undefined';
        },

        element() {
            if (this.$parent.$options.name === 'list-group' && this.$parent.type === 'list') {
                return 'li';
            }

            return 'a';
        },

        computeProps() {
            let props = {
                class: this.classObject
            };

            if (this.element === 'a') {
                props.href = this.link;
            }

            return props;
        }
    }
}
</script>

<template>
    <component 
        :is="element" 
        v-bind="computeProps"
        @click="$emit('click')"
    >
        <span class="badge" v-if="hasBadgeContent">{{badgeContent}}</span>
        <slot></slot>
    </component>
</template>
